import React, { useEffect, useState } from "react";
import { FormContext } from "../context/FormContext";
import Header from "../components/Main/Header/Header";
import Hero from "../components/Main/Hero/Hero";
import Roadmap from "../components/Main/Roadmap/Roadmap";
import Form from "../components/Main/Form/Form";
import Survey from "../components/Main/Survey/Survey";
import Link from "../components/Main/Link/Link";
import Footer from "../components/Main/Footer/Footer";
import { useSearchParams } from "react-router-dom";

function HomePage() {
  const [formData, setFormData] = useState({
    selectedBouquets: [],
    selectedColors: [],
    userName: "",
    flowerRatings: [], // {id: number, text: string}
  });
  const [searchParams] = useSearchParams();
  const urlParam = searchParams.get("url");
  const urlLink = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (urlParam) {
      fetch(`${urlLink}api/?url=${urlParam}/`)
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
        });
    }
  }, [urlParam]);

  return (
    <FormContext.Provider value={{ formData, setFormData }}>
      <Header />
      <Hero />
      <Roadmap />
      <Form />
      <Survey />
      <Link />
      <Footer />
    </FormContext.Provider>
  );
}

export default HomePage;
